export default __webpack_public_path__ + "static/media/kvadrat.5bf2799d.svg";